<template>
    <button class="btn-practice-restart">
        <span class="btn-practice-restart__text">TEKRAR</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/btn-practice-restart.css"></style>